<template>
    <div>
        <v-card flat>
            <v-card-title>
                <span class="text-h5">{{ title }}</span>
                <v-spacer></v-spacer>
                <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" single-line
                    hide-details></v-text-field>
            </v-card-title>
            <v-card-text>
                <v-container>

                    <v-data-table :headers="headers" :items="itemsDetails" :search="search"
                        class="elevation-1 custom-font">
                    </v-data-table>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-btn color="blue darken-1" text @click="cloneStock">
                    Clonar
                </v-btn>
                <v-alert shaped dense dark type="info" v-if="info !== ''">
                    {{ info }}
                </v-alert>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="cancelStock">
                    Cerrar
                </v-btn>
                <v-btn color="blue darken-1" text @click="saveStock">
                    Imprimir
                </v-btn>
            </v-card-actions>
        </v-card>
        <div>
            <ReportDataPdfBasic v-if="dataReady" :name="title" :title="title" :elementsPerPag=20 :headerAll=false
                :headers="headers" :items="itemsDetails" :inf="hoy" ref="pdfComponent" />

        </div>
    </div>
</template>
<script>
import { getKitById } from '../dataApi'
import UserProfile from "../data";
import ReportDataPdfBasic from "./report-data-basic-pdf.vue";
import { format } from "@formkit/tempo"
export default {
    components: {
        ReportDataPdfBasic
    },
    props: {
        kit: {
            type: Number,
            required: true
        }
    },
    name: 'kitsView',
    data: () => ({
        user: UserProfile.getUserData(),
        itemsDetails: [],
        dataReady: false,
        headers: [
            //{ text: 'Sexo', value: 'sex' },
            { text: 'Posicion', value: 'position' },
            { text: 'Categoria Producto', value: 'category.name' },
            { text: 'Cantidad', value: 'quantity' },
            { text: 'Renovacion', value: 'durationMonths' },
            //{ text: "Acciones", value: "actions", sortable: false },
        ],
        info: "",
        ref: "",
        costCenter: "",
        search: "",
    }),

    methods: {
        async createdValuesItems() {
            const kit = await getKitById(this.kit)
            this.itemsDetails = kit.items
            this.ref = kit.ref
            this.costCenter = data.costCenter
        },

        cloneStock() {
            this.$emit("cloneKit", this.kit)
        },

        cancelStock() {
            this.$emit("closeModal")
        },
        saveStock() {
            this.dataReady = true
            setTimeout(() => {
                this.$refs.pdfComponent.generatePdf()
            }, 500)
        }
    },

    mounted() {
        this.createdValuesItems();
    },

    computed: {
        hoy() {
            const date = new Date();
            return format(date, 'DD-MM-YYYY H:mm:ss', 'es')
        },
        title() {
            return `Set de Productos: ${this.ref} - ${this.costCenter}`
        }
    }
}
</script>